import dayjs from 'dayjs';

import type {NaiveDateTimeObj} from './types';

import {ISOStringToNaiveDatetimeObj} from './ISOStringToNaiveDatetimeObj';

export const timestampToNaiveDateTimeObj = (
  timeStamp: number,
): NaiveDateTimeObj => {
  return ISOStringToNaiveDatetimeObj(dayjs(timeStamp).toISOString());
};
